import moment from 'moment';

export const isCardExpired = (expiration, format = 'M/YYYY') => {
  if (!expiration) return false;

  return moment(expiration, format).isBefore(moment().startOf('month'));
};
